import React from "react";
import {useLocation} from "react-router";
import Button from "../../ui/PrimaryButton";
import UIContainer from "../../ui/UIContainer";

export default function NotFoundScene() {
  const location = useLocation();

  return (
    <UIContainer className="pt-40 pb-4 flex flex-col items-center">
      <h1 className="m-0 p-0 text-4xl font-bold">Oooops... 404</h1>
      <p className="text-xl mt-4">We cannot find the page you&apos;re looking for: {location.pathname}</p>
      <p className="text-l opacity-80">Let’s start from the beginning</p>
      <Button to='/dashboard' className="w-44 mt-8 text-l">
        Go to dashboard
      </Button>
    </UIContainer>
  )
}
